export default __webpack_public_path__ + "static/media/youtubeIcon.a2da55eb.svg";